export const formFields = [
  {
    section: "General Information",
    name: "cpfGpiListName",
    label: "List",
    fieldLabel: "CPF GPI List Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [5, 8],
  },
  {
    section: "General Information",
    name: "cpfGpiListDescription",
    label: "Description",
    fieldLabel: "Description 30",
    type: "text",
    options: { maxLength: { value: 30, message: "MAXLENGTH_30" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [6, 8],
  },
  {
    section: "General Information",
    name: "cpgGenericProductId",
    label: "GPI",
    fieldLabel: "CPG Generic Product ID",
    type: "lookup",
    externalProgram: { default: "RCGPI031" },
    viewMode: "text",
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          {
            source: "cpgGenericProductId",
            target: "gpiId",
            paramDataKey: "gpiId",
            legacy: "gp3GpiMscListId",
          },
          {
            source: "gpiName",
            target: "gpiName",
            paramDataKey: "NA",
            legacy: "gp3GpiMscListDesc",
          },
        ],
        gpiName: [
          {
            source: "gpiName",
            target: "gpiName",
            paramDataKey: "gpiName",
            legacy: "gp3GpiMscListDesc",
          },
          {
            source: "cpgGenericProductId",
            target: "gpiId",
            paramDataKey: "gpiId",
            legacy: "gp3GpiMscListId",
          },
        ],
        productId: [
          {
            source: "cpgGenericProductId",
            target: "gpiId",
            paramDataKey: "NA",
            legacy: "gp3GpiMscListId",
          },
          {
            source: "gpiName",
            target: "gpiName",
            paramDataKey: "gpiName",
            legacy: "gp3GpiMscListDesc",
          },
        ],
      },
    },
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 14, message: "MAXLENGTH_14" },
    },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [7, 8],
  },
  {
    section: "General Information",
    name: "gpiName",
    label: "",
    fieldLabel: "GPI Name",
    type: "text",
    options: { readOnly: true },
    // options: { maxLength: { value: 30, message: "MAXLENGTH_30" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [7, 12],
  },
  {
    section: "General Information",
    name: "cpgFromDate",
    label: "From Date",
    fieldLabel: "CPG From Date7",
    type: "date",
    format: "MM/DD/YYYY",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 8],
  },
  {
    section: "General Information",
    name: "cpgThruDate",
    label: "Thru Date",
    fieldLabel: "CPG Thru Date7",
    type: "date",
    format: "MM/DD/YYYY",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 8],
  },
  {
    section: "General Information",
    name: "cpgStatus",
    label: "Status",
    fieldLabel: "Hidden Records Indicator",
    type: "dropdown",
    dropdownCondition: "*Inactive",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 2, message: "MAXLENGTH_2" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [10, 8],
  },
  // { section: 'General Information', name: 'statusDescription', label: 'Status Description', fieldLabel: 'Status Description', type: 'text', options: { maxLength: { value: 25, message: 'MAXLENGTH_25' } }, fieldNature: 'Add: Read-only, Change: Read-only, View: Read-only', position: [8, 51] },
  {
    section: "General Information",
    name: "cpgMfgMinimumPatPay",
    label: "Mfg Patient Pay Amount",
    fieldLabel: "CPG Mfg Minimum Pat Pay",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [11, 8],
  },
  {
    section: "General Information",
    name: "cpgExpectedCouponAmt",
    label: "Expected Coupon Amount",
    fieldLabel: "CPG Expected Coupon Amt",
    type: "number",
    fractionDigits: 2,
    options: {
      required: { value: true, message: "REQUIRED" },
      min: { value: 0, message: "MIN_0" },
      max: { value: 999999.99, message: "MAX_999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [12, 8],
  },
  {
    section: "General Information",
    name: "cpgPharPatPaySchedule",
    label: "Pharmacy Patient Pay",
    fieldLabel: "CPG Phar Pat Pay Schedule",
    type: "lookup",
    externalProgram: { default: "RCPS3001" },
    params: {
      lookupType: "local",
      viewType: "local",
      disabledDropdown: true,
      fieldMapping: {
        default: [
          {
            source: "cpgPharPatPaySchedule",
            target: "ps3PatientPaySchName",
            paramDataKey: "scheduleName",
          },
          {
            source: "cpgPharPatPayScheduleDesc",
            target: "ps3PatientPaySchDesc",
            paramDataKey: "NA",
          },
        ],
      },
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [13, 8],
  },
  {
    section: "General Information",
    name: "cpgPharPatPayScheduleDesc",
    label: "",
    fieldLabel: "Wrk Description 25",
    type: "text",
    options: { readOnly: true },
    fieldNature: "Add: Read-Only, Change: Read-Only, View: Read-only",
    position: [13, 23],
  },
  {
    section: "General Information",
    name: "cpgClntPatPaySchedule",
    label: "Client Patient Pay",
    fieldLabel: "CPG Clnt Pat Pay Schedule",
    type: "lookup",
    externalProgram: { default: "RCPS3001" },
    params: {
      lookupType: "local",
      viewType: "local",
      disabledDropdown: true,
      fieldMapping: {
        default: [
          {
            source: "cpgClntPatPaySchedule",
            target: "ps3PatientPaySchName",
            paramDataKey: "scheduleName",
          },
          {
            source: "cpgClntPatPayScheduleDesc",
            target: "ps3PatientPaySchDesc",
            paramDataKey: "NA",
          },
        ],
      },
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [14, 8],
  },
  {
    section: "General Information",
    name: "cpgClntPatPayScheduleDesc",
    label: "",
    fieldLabel: "Wrk Description 25",
    type: "text",
    options: { readOnly: true },
    fieldNature: "Add: Read-Only, Change: Read-Only, View: Read-only",
    position: [14, 23],
  },
  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "date",
    format: "MM/DD/YY",
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 20],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "date",
    format: "MM/DD/YY",
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 40],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 57],
  },
  {
    section: "Audit Fields",
    name: "noteExistenceStatus",
    label: "Note Exists",
    fieldLabel: "Note Existence Status",
    type: "text",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 70],
  }
];
